import { css } from '@emotion/core'

export const CompanyInfoStyle = css`
  width: 100%;
  height: auto;
  margin-top: 24px;
  image-rendering: -webkit-optimize-contrast;
  margin-bottom: -57px;
`
